// extracted by mini-css-extract-plugin
module.exports = {"footer":"_5D1xJ-eK","privacy-policy":"_5D2UE2Zo","copy-right-text":"_5D3kAcrg"};